module.exports = __webpack_public_path__ + "img/hdbj-title.9f6f5349.png";